import store from 'store2'

export default class LocalStore extends Backbone.Collection {
  get key () { return 'local_store' }

  initialize (attrs, options = {}) {
    this.on('change', this.sync.bind(this))
    this.on('update', this.sync.bind(this))

    this.fetch()
  }

  // persist
  sync () {
    store.set(this.key, this.toJSON())
  }

  // load
  fetch () {
    const value = store.get(this.key)
    if (value) {
      this.set(value)
    }
  }

  reset () {
    this.set([])
    this.sync()
  }
}
